import create from 'zustand';

import { StorageE } from 'declarations/enums/storage';

type UseAuthStoreT = {
  isUserLoggedIn: boolean;
  setUserLoginStatus: (isUserLoggedIn: boolean) => void;
};

const hasToken = !!localStorage.getItem(StorageE.IdToken);

const useAuthStore = create<UseAuthStoreT>(set => ({
  isUserLoggedIn: hasToken,
  setUserLoginStatus: isUserLoggedIn => set({ isUserLoggedIn }),
}));

export default useAuthStore;
